<template>
  <vx-card no-shadow>
    
   
    <!-- Mobile Number -->
    <vs-input class="w-full mt-8" type="number" label-placeholder="Mobile" v-model="mobile" />

    <!-- adresse  -->
    <vs-input class="w-full mt-8" label-placeholder="adresse" v-model="adresse" />

            
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-5" @click="save_changes">Save Changes</vs-button>
      <vs-button class="ml-4 mt-5" type="border" @click="reset_data" color="warning">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import axios from "../../../http/axios/index.js"

export default {
  components: {
    flatPickr,
    vSelect
  },
  data() {
    return {
      id: this.$store.state.AppActiveUser.id,
      bio: this.$store.state.AppActiveUser.about,
      dob: null,
      country: "USA",
      lang_known: ["English", "Russian"],
      gender: "male",
      role:this.$store.state.AppActiveUser.role,
      datagrade: this.$store.state.AppActiveUser.grade,
      mobile: this.$store.state.AppActiveUser.mobile,
      adresse: this.$store.state.AppActiveUser.adresse,
      domaine: this.$store.state.AppActiveUser.domaine,
      grade_choices: [
        { label: 'Professeur', value: 'Professeur' },
        { label: 'Maître de conférences', value: 'Maître de conférences' },
        { label: 'Maître assistant', value: 'Maître assistant' },
        { label: 'Assistant', value: 'Assistant' },
        { label: 'Professeur technologue', value: 'Professeur technologue' },
        { label: 'Maître technologue', value: 'Maître technologue' },
        { label: 'Technologue', value: 'Technologue' },
        { label: 'Assistant technologue', value: 'Assistant technologue' },
      ],
      // Options
      countryOptions: [
        { label: "Australia",  value: "australia"  },
        { label: "France",     value: "france"     },
        { label: "Germany",    value: "germany"    },
        { label: "India",      value: "india"      },
        { label: "Jordan",     value: "jordan"     },
        { label: "Morocco",    value: "morocco"    },
        { label: "Portuguese", value: "portuguese" },
        { label: "Syria",      value: "syria"      },
        { label: "USA",        value: "usa"        },
      ],
      langOptions: [
        { label: "English",  value: "english"  },
        { label: "Spanish",  value: "spanish"  },
        { label: "French",   value: "french"   },
        { label: "Russian",  value: "russian"  },
        { label: "German",   value: "german"   },
        { label: "Arabic",   value: "arabic"   },
        { label: "Sanskrit", value: "sanskrit" },
      ],
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  
  methods: {
    
    save_changes() {
      axios.post("https://trainingcenterback.codily.net/api/update_Candidat/"+this.id, {
        nom: this.$store.state.AppActiveUser.nom,
        prenom: this.$store.state.AppActiveUser.prenom,
        email: this.$store.state.AppActiveUser.email,
        mobile: this.mobile,
         adresse: this.adresse,
          password: this.$store.state.AppActiveUser.password,
        //password: this.password,

      } ).then((response) => {
          console.log("admins",response.data)
          
        this.$store.dispatch('auth/updateauth', response.data)
        })
      
      //console.log(this.name)
      /*if (this.validateForm ) console.log("22") 
      console.log(this.old_password)
      console.log(this.new_password)
      console.log(this.confirm_new_password)*/
    this.showMessage('success', 'update', 'successfully update') 
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'compte '+title,
                text: 'The compte was '+text
              })
            },
    reset_data() {
     this.mobile= this.$store.state.AppActiveUser.mobile
     this.adresse= this.$store.state.AppActiveUser.adresse
    },
}}
</script>
